import {createEntityAdapter} from '@reduxjs/toolkit';
import {Workday} from '../entities';

export const workdaysAdapter = createEntityAdapter<Workday>();
